import React, { useState } from 'react';
import { Modal } from '@material-ui/core';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { Container, WrapperInput, WrapperButtons, FileUploadArea, FileList, FileItem } from './styles';

export default function ModalAnexarXml({ open, onClose, onConfirm, freteId }) {
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const xmlFiles = files.filter(f => f.name.toLowerCase().endsWith('.xml'));
    
    if (xmlFiles.length !== files.length) {
      setErro('Apenas arquivos XML são permitidos');
      return;
    }
    
    setArquivos([...arquivos, ...xmlFiles]);
    setErro('');
  };

  const handleRemoveFile = (index) => {
    setArquivos(arquivos.filter((_, i) => i !== index));
  };

  const parseXml = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const xmlText = e.target.result;
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
          
          // Extrai informações do XML
          const chaveAcesso = xmlDoc.querySelector('chNFe, chCTe')?.textContent || '';
          const numero = xmlDoc.querySelector('nNF, nCT')?.textContent || '';
          const tipo = xmlDoc.querySelector('NFe') ? 'NFe' : 
                       xmlDoc.querySelector('CTe') ? 'CTe' : 'Outro';
          
          resolve({
            xml_content: xmlText,
            xml_filename: file.name,
            xml_chave: chaveAcesso,
            xml_numero: numero,
            xml_tipo: tipo,
          });
        } catch (error) {
          reject(new Error(`Erro ao processar ${file.name}: ${error.message}`));
        }
      };
      reader.onerror = () => reject(new Error(`Erro ao ler ${file.name}`));
      reader.readAsText(file);
    });
  };

  const handleConfirm = async () => {
    if (arquivos.length === 0) {
      setErro('Selecione pelo menos um arquivo XML');
      return;
    }

    setLoading(true);
    setErro('');
    
    try {
      const xmlsParsed = await Promise.all(
        arquivos.map(file => parseXml(file))
      );
      
      await onConfirm(xmlsParsed);
      handleClose();
    } catch (error) {
      setErro(error.message || 'Erro ao anexar XMLs');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setArquivos([]);
    setErro('');
    setLoading(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Container>
        <h2 style={{ marginBottom: '20px' }}>Anexar XMLs ao Frete</h2>

        <FileUploadArea>
          <input
            type="file"
            accept=".xml"
            multiple
            onChange={handleFileSelect}
            style={{ display: 'none' }}
            id="xml-file-input"
          />
          <label htmlFor="xml-file-input" style={{ cursor: 'pointer' }}>
            <div style={{ 
              border: '2px dashed #ccc', 
              borderRadius: '8px', 
              padding: '40px', 
              textAlign: 'center',
              backgroundColor: '#f9f9f9'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>📄</div>
              <div style={{ fontSize: '16px', color: '#666' }}>
                Clique aqui ou arraste arquivos XML
              </div>
              <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>
                Você pode selecionar múltiplos arquivos
              </div>
            </div>
          </label>
        </FileUploadArea>

        {arquivos.length > 0 && (
          <FileList>
            <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>
              Arquivos selecionados ({arquivos.length})
            </h3>
            {arquivos.map((file, index) => (
              <FileItem key={index}>
                <span>📄 {file.name}</span>
                <span style={{ fontSize: '12px', color: '#999' }}>
                  {(file.size / 1024).toFixed(2)} KB
                </span>
                <button
                  onClick={() => handleRemoveFile(index)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#f44336',
                    cursor: 'pointer',
                    fontSize: '18px',
                  }}
                >
                  ×
                </button>
              </FileItem>
            ))}
          </FileList>
        )}

        {erro && (
          <div style={{ color: '#f44336', marginTop: '10px', fontSize: '14px' }}>
            {erro}
          </div>
        )}

        <WrapperButtons>
          <Button
            label="Cancelar"
            type="button"
            onClick={handleClose}
            disabled={loading}
            style={{ backgroundColor: '#999' }}
          />
          <Button
            label={loading ? 'Anexando...' : 'Anexar XMLs'}
            type="button"
            onClick={handleConfirm}
            disabled={loading || arquivos.length === 0}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

